"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bookingStatus;
(function (bookingStatus) {
    bookingStatus[bookingStatus["waiting"] = 0] = "waiting";
    bookingStatus[bookingStatus["waitingForConfirm"] = 1] = "waitingForConfirm";
    bookingStatus[bookingStatus["created"] = 2] = "created";
    bookingStatus[bookingStatus["planned"] = 3] = "planned";
    bookingStatus[bookingStatus["notCame"] = 4] = "notCame";
    bookingStatus[bookingStatus["came"] = 5] = "came";
    bookingStatus[bookingStatus["payed"] = 6] = "payed";
})(bookingStatus || (bookingStatus = {}));
var bookingCreator;
(function (bookingCreator) {
    bookingCreator[bookingCreator["WEBSITE"] = 0] = "WEBSITE";
    bookingCreator[bookingCreator["BACKOFFICE"] = 1] = "BACKOFFICE";
    bookingCreator[bookingCreator["RWG"] = 2] = "RWG";
    bookingCreator[bookingCreator["LE_CISEAU"] = 3] = "LE_CISEAU";
    bookingCreator[bookingCreator["TREATWELL"] = 4] = "TREATWELL";
    bookingCreator[bookingCreator["APPMOBILE_PRO"] = 5] = "APPMOBILE_PRO";
    bookingCreator[bookingCreator["APPMOBILE_CLI"] = 6] = "APPMOBILE_CLI";
    bookingCreator[bookingCreator["BACKOFFICE_KIUTE_PRO"] = 7] = "BACKOFFICE_KIUTE_PRO";
})(bookingCreator || (bookingCreator = {}));
var bookingCreatorValue;
(function (bookingCreatorValue) {
    bookingCreatorValue[bookingCreatorValue["internet"] = 0] = "internet";
    bookingCreatorValue[bookingCreatorValue["backoffice"] = 1] = "backoffice";
    bookingCreatorValue[bookingCreatorValue["google"] = 2] = "google";
    bookingCreatorValue[bookingCreatorValue["leCiseau"] = 3] = "leCiseau";
    bookingCreatorValue[bookingCreatorValue["treatwell"] = 4] = "treatwell";
    bookingCreatorValue[bookingCreatorValue["appmobilePro"] = 5] = "appmobilePro";
    bookingCreatorValue[bookingCreatorValue["appmobileCli"] = 6] = "appmobileCli";
    bookingCreatorValue[bookingCreatorValue["backofficeKiutePro"] = 7] = "backofficeKiutePro";
})(bookingCreatorValue || (bookingCreatorValue = {}));
